Postlogin = (function (self) {
    self.UsersPermissions = {};
    const me = self.UsersPermissions;

    me.init = function () {
        /*
         * Add or Remove a specific permission for a specific user
         */
        $('#user-permissions .permissions-hierarchy .checkbox input:checkbox').change(function () {
            const $checkbox = $(this);
            const userId = $checkbox.attr('data-user-id');
            const permissionId = $checkbox.attr('data-permission-id');

            if ($checkbox.prop('checked')) {
                $checkbox.closest('li').addClass('checked');
                $.ajax({
                    url: $('.permissions-hierarchy').attr('data-grant-url'),
                    type: 'POST',
                    data: {
                        user_id: userId,
                        permission_id: permissionId,
                    },
                    success(data) {
                        VjsUtility.Notification.success({
                            title: 'Permission Granted',
                            text: data.data.message,
                        });
                    },
                    error(data) {
                        $checkbox.closest('li').removeClass('checked');
                        $checkbox.prop('checked', false);
                        let errorMessage;
                        if (data.status < 400) {
                            errorMessage = 'You do not have access to perform this action.';
                        } else {
                            errorMessage = data.responseJSON.errors;
                        }

                        VjsUtility.Notification.error({
                            title: 'Error Granting User Permissions',
                            text: errorMessage,
                        });
                    },
                });
            } else {
                $checkbox.closest('li').removeClass('checked');
                $.ajax({
                    url: $('.permissions-hierarchy').attr('data-revoke-url'),
                    type: 'POST',
                    data: {
                        user_id: userId,
                        permission_id: permissionId,
                    },
                    success(data) {
                        VjsUtility.Notification.success({
                            title: 'Permission Revoked',
                            text: data.data.message,
                        });
                    },
                    error(data) {
                        $checkbox.closest('li').addClass('checked');
                        $checkbox.prop('checked', true);
                        let errorMessage = '';
                        if (data.status < 400) {
                            errorMessage = 'You do not have access to perform this action.';
                        } else {
                            errorMessage = data.responseJSON.errors;
                        }

                        VjsUtility.Notification.success({
                            title: 'Error Revoking User Permissions',
                            text: errorMessage,
                        });
                    },
                });
            }
        });
    };

    return self;
}(Postlogin || {}));
